
import TimerEvent from "../events/TimerEvent.ts";

export default class Timer
{
    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Private:
    //----------------------------------

    private _currentCount:number;
    private _delay:number;
    private _repeatCount:number;
    private _running:boolean;
    private eventDispatcher:EventTarget = new EventTarget();
    private interval: number | null;
    private pausedTime:number;
    private startTime:number;

    //----------------------------------
    //  Public:
    //----------------------------------

    public id:number;

    //--------------------------------------------------------------------------
    //
    //  Getters/Setters
    //
    //--------------------------------------------------------------------------

    public get currentCount():number
    {
        return this._currentCount;
    }

    public get delay():number
    {
        return this._delay;
    }

    public set delay(value:number)
    {
        this._delay = value;
    }

    public get repeatCount():number
    {
        return this._repeatCount;
    }

    public set repeatCount(value:number)
    {
        this._repeatCount = value;
    }

    public get running():boolean
    {
        return this._running;
    }

    //----------------------------------
    //  Public:
    //----------------------------------

    //--------------------------------------------------------------------------
    //
    //  Constructor
    //
    //--------------------------------------------------------------------------

    constructor(delay:number, repeatCount:number=-1)
    {
        if(repeatCount == 0)
        {
            throw new Error("The repeat count must be set to a value other than zero. Set the repeat count to -1 to repeat indefinitely.");
        }
        this._delay = delay;
        this._repeatCount = repeatCount;

        this._init();
    }

    //--------------------------------------------------------------------------
    //
    //  Methods
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Private:
    //----------------------------------

    private _init():void
    {
        this._currentCount = 0;
    }

    private handleInterval = () =>
    {
        this._currentCount++;
        if(this._currentCount == this._repeatCount)
        {
            this.stop();
            this.eventDispatcher.dispatchEvent(new CustomEvent(TimerEvent.TIMER_COMPLETE, {detail:{target:this}}));
            return;
        }
        this.eventDispatcher.dispatchEvent(new CustomEvent(TimerEvent.TIMER, {detail:{target:this}}));
    }

    //----------------------------------
    //  Public:
    //----------------------------------

    public addCustomEventListener(type:string, listener:EventListenerOrEventListenerObject, options?:boolean | AddEventListenerOptions):void
    {
        this.eventDispatcher.addEventListener(type, listener, options);
    }
    
    public pause():void
    {
        this.pausedTime = new Date().getTime();
        this.stop();
    }

    public removeCustomEventListener(type:string, listener:EventListenerOrEventListenerObject, options?:boolean | EventListenerOptions):void
    {
        this.eventDispatcher.removeEventListener(type, listener, options);
    }

    /**
     * Resets the Timer by stopping it and resetting the current count.
     * @public
     */
    public reset():void
    {
        this.stop();
        this._currentCount = 0;
        this.interval = null;
    }
    
    public resume():void
    {
        const resumeTime = this.pausedTime - this.startTime;
        if(resumeTime > this._delay)
        {
            this._delay = 500;
        }
        else
        {
            this._delay = this._delay - resumeTime;
        }
        this.start();
    }

    public start():void
    {
        if(this.interval)
        {
            clearInterval(this.interval);
        }
        this.interval = window.setInterval(this.handleInterval, this._delay);
        this.startTime = new Date().getTime();
        this._running = true;
    }

    public stop():void
    {
        if(this.interval)
        {
            clearInterval(this.interval);
        }
        this._running = false;
    }

}
